module.exports = {"id":"158625","name":"Dante","rating":"80","photo":"./data/images/photos/1/158625.png","club":{"name":"OGC Nice","logo":"./data/images/clubs/OGCNice.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Dante0.json
// module id = 969
// module chunks = 0